import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getBenefitCardPreview = ({ benefitId, groupId }) =>
  call(websocketFetch, 'get_benefit_card_preview', {
    benefit_id: benefitId,
    group_id: groupId,
  });
